import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { CONTACT } from "../../constant/constant";
import {
  resetPdfFile,
  getSearchProviders,
} from "../../redux/slice/provider-search/searchProvidersSlice";
import Dialog from "../common/Dialog";
import { t } from "i18next";

const DownloadPDF = ({ providerData, isProviderNetworkSearch }) => {
  const dispatch = useDispatch();
  const { pdfFile, providers } = useSelector((state) => state.searchProviders);
  const [showModal, setShowModal] = useState(false);

  useEffect(() => {
    if (pdfFile !== "") {
      downloadPdfFromBase64(pdfFile);
      dispatch(resetPdfFile());
    }
  }, [pdfFile]);

  const downloadPdfFromBase64 = (base64File) => {
    const decodedPdf = atob(base64File);

    const bytes = new Uint8Array(decodedPdf.length);
    for (let i = 0; i < decodedPdf.length; i++) {
      bytes[i] = decodedPdf.charCodeAt(i);
    }

    const blob = new Blob([bytes], { type: "application/pdf" });
    const url = URL.createObjectURL(blob);

    const newTab = window.open(url, "_blank");
    if (!newTab) {
      alert(
        t("browser-blocked-pdf")
      );
    }
  };

  const handleGeneratePdf = async () => {
    if (providers.length === 0) {
      setShowModal(true);
    } else {
      const payload = {
        ...providerData,
        isDownloadPdf: true,
        isSpecialitySearch: isProviderNetworkSearch,
      };
      dispatch(getSearchProviders(payload));
    }
  };

  return (
    <>
      <div className="container-fluid">
        <div className="btn-argusnetwork">
          <button
            type="button"
            className="btn btn-argusnetwork-icon"
            onClick={handleGeneratePdf}
          >
            <i className="icon-file" aria-hidden="true"></i>{" "}
            <span className="map-style">
              {t("download-pdf")}
            </span>
          </button>
        </div>
        <div className="contact-details">
          {t("please-contanct-health-services")}{" "}
          <a className="bluecolor" href={`tel:${CONTACT.CALL_COLLECT_NUMBER}`}>
            {CONTACT.CALL_COLLECT_NUMBER}
          </a>{" "}
          {t("additional-line")}
        </div>
      </div>
      {showModal && (
        <Dialog
          setVisible={setShowModal}
          message={t("no-result-to-download")}
        />
      )}
    </>
  );
};

export default DownloadPDF;
